

export const SpecificityPage = () => {

  return(<div className="css-page">
    <h2>Specificity</h2>
  </div>)
}